export const WIDGET_MICRO_APP_TYPE = 'micro-app';
